import angular from 'angular';
import template from './template.html';
import './style.scss';

export class SelectEmailTemplate {
    templateOptions = [];

    selectedCandidatesEmails = [];

    selectedCandidatesEmailsLabel = '';

    isSelectedCandidatesEmailsValid = false;

    /* @ngInject */
    constructor($scope, $timeout, $filter) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
    }

    $onChanges() {
        this.selectedCandidatesEmailsLabel = this.getSelectedCandidatesEmailsLabel(this.candidates);
    }

    getSelectedCandidatesEmailsLabel(candidates) {
        return `${candidates.length} ${this.$filter('translate')('CANDIDATES')}`;
    }

    onTemplateChanged(option) {
        this.onEmailTemplateChange({ option });
    }

    onTemplateEmailChanged(email) {
        this.onEmailChange({ email });
    }

    onEditStateChanged(state) {
        this.onEmailTextareaEditStateChange({ state });
    }
}

export const selectEmailTemplateConfiguration = {
    template,
    bindings: {
        candidates: '<',
        recruiter: '<',
        position: '<',
        email: '<',
        isFormLoading: '<',
        templateOptions: '<',
        selectedTemplateIndex: '<',
        isSelectedCandidatesEmailsValid: '<',
        emailTextareaEditState: '<',
        onEmailTemplateChange: '&',
        onSelectCandidateEmailsClick: '&',
        onEmailTextareaEditStateChange: '&',
        onEmailChange: '&',
        onClose: '&',
        onSend: '&',
    },
    controller: SelectEmailTemplate,
    controllerAs: 'selectEmailTemplateCtrl',
};

angular.module('TALENYA-FE').component('selectEmailTemplate', selectEmailTemplateConfiguration);